import React, { DragEvent, useEffect, useState, useCallback } from "react";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";
import { isEmpty, size, toArray } from "lodash";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { Checkbox } from "./../../Components/Checkbox";
import Link from "@pages/ShieldStarter/Components/Link";
import Button from "@pages/ShieldStarter/Components/Button";
import {
  updatePersonalInfo,
  updatePersonalChildInfo,
  updateReadyToGoNext,
  updateTransactionId,
  updateRentalPostalCustomer,
  updateConsentForMinor,
  ConsentTypes,
  consentForMinorProps,
  setUploadFile,
  FileProgress,
  setUploadProgress,
  successUploadFile,
  failureUploadFiles,
  deleteUploadedFile,
  clearUploadedFiles,
  uploadStatus,
  deleteSignature,
  updateSingpassInitiated,
} from "@redux/slices/SHIELD_STARTER/step3Slice";
import {
  deleteDocuments,
  postContactShield,
  postMyInfoRecord,
  postValidateUserDetails,
  uploadDocuments,
} from "@api/index";
import { Helpers } from "@utils/helpers";
import { useHistory } from "react-router-dom";
import ErrorModal from "@pages/ShieldStarter/Components/Modals/ErrorModal";
import { ROUTE_PATH } from "@static/route-paths";
import { setLoadingState } from "@redux/slices/loadingSlice";
import ChildInfo from "./ChildInfo";
import MyInfoForm from "./MyInfoForm";
import MainContainer from "@pages/ShieldStarter/Components/Container";
import { trackOnLoad } from "@pages/ShieldStarter/Helpers/dataAnalyticsHelpers";
import { updateApiError } from "@redux/slices/SHIELD_STARTER/step1Slice";
import fetchSqsQuotation from "@pages/ShieldStarter/Helpers/fetchSqsQuotation";
import { SCREEN_SIZE } from "@static/screen-size";
import { InputGroup } from "@components/_Revamp/InputGroup";
import AttachFileIcon from "@assets/icon/attach-file.svg";
import { themeDefault } from "src/theme-revamp";
import infoIconBlack from "@assets/icon/info-black.svg";
import {
  CONSENT_ACCEPT_DECLARATION,
  CONSENT_LABEL,
  FILE_INSTRUCTIONS,
} from "@static/content";
import Modal from "@pages/ShieldStarter/Components/Modals/Modal";
import photoGuidIcon1 from "@assets/images/photo-guid-icon-1.svg";
import photoGuidIcon2 from "@assets/images/photo-guid-icon-2.svg";
import photoGuidIcon3 from "@assets/images/photo-guid-icon-3.svg";
import photoGuidIcon4 from "@assets/images/photo-guid-icon-4.svg";
import SingnatureCanvas from "@pages/ShieldStarter/Components/SignatureCanvas";
import FileUploadCard from "@pages/ShieldStarter/Components/FileUploader/FileUploadCard";
import ConsentChangeModal from "@pages/ShieldStarter/Components/Modals/ConsentChangeModal";
import {
  isFileDuplicated,
  isFileSizeAllowed,
  isFileTypeAllowed,
} from "@pages/ShieldStarter/Components/FileUploader/upload-utils";
import {
  ACCEPTED_FILE_TYPES,
  MAX_FILE_SIZE_MB,
  MAX_FILE_UPLOAD_COUNT,
} from "@static/config";
import { Text as Typography } from "@pages/ShieldStarter/Components/Text";

const SectionContainer = styled.div<{ margin?: string }>`
  background-color: #ffffff;
  border-radius: 24px;
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  // gap: 64px;
  transition: all 0.2s ease;
  max-width: 792px;
  margin: 50px auto auto;
  padding: 24px 16px;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 24px 64px;
  }
`;

interface TextProps {
  color?: string;
  fSize?: string;
  weight?: number;
  mg?: string;
  mbFsize?: string;
}

const Text = styled.div<TextProps>`
  color: ${(props) =>
    props.color ? props.color : themeDefault.colors.grey[500]};
  font-weight: ${(props) => (props.weight ? props.weight : 600)};
  font-size: ${(props) => (props.fSize ? props.fSize : "12px")};
  margin: ${(props) => (props.mg ? props.mg : "0")};
  @media screen and (max-width: 588px) {
    font-size: ${(props) => props.mbFsize || "16px"};
    line-spacing: 140%;
  }
`;

const TextNormal = styled.div`
  color: #434343;
  margin: 0;

  @media screen and (max-width: 588px) {
    line-spacing: 19.6px;
  }
`;

const Wrap = styled.div`
  max-width: 792px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0 16px;
  flex-direction: column;
  flex-wrap: wrap;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 0 64px;
  }
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 8px;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    flex-direction: row;
  }
`;

const LinkCss = css`
  u {
    white-space: nowrap;
  }
`;

const ConsentButtonCss = css`
  font-size: 14px;
`;

const SelectedParent = styled.div`
  width: 100%;
`;

const SignArea = styled.div`
  margin-top: 40px;
`;

const Label = styled.div`
  font-size: 14px;
  color: #434343;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.8;
  margin-bottom: 16px;
`;

const SignBox = styled.div`
  border-radius: 8px;
  border: 1px solid #D8D8D8;
  color: #C9C9C9;
  background: #ffffff;
  height: 116px;
  padding: 16px;
  margin-top: 16px;
`;

const SignImage = styled.img`
  height: 100%;
  object-fit: contain;
`;

const SignContainer = styled.div<{ isDisabled: boolean }>`
  cursor: pointer;
  opacity: ${(props) => (props.isDisabled ? 0.7 : 1)};
`;

const AttachFileDiv = styled.div<{ isDragOver: boolean; isDisabled: boolean }>`
  margin-top: 48px;
  padding: 8px;
  border-radius: 8px;
  border: ${(props) =>
    props.isDragOver
      ? `1px dashed ${themeDefault.colors.primary}`
      : `1px dashed transparent`};
  pointer-events: ${(props) => (props.isDisabled ? `none` : `auto`)};

  span {
    pointer-events: auto;
  }
`;

const AttachFileCss = css`
  color: #883E89;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

const Info = styled.div`
  margin-top: 24px;
  font-size: 14px;
  display: flex;
  padding: 16px 24px;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  border-radius: 16px;
  background: #f5f5f5;
`;

const AcceptConsent = styled.div<{ noMargin: boolean }>`
  margin-top: ${(props) => (props.noMargin ? "" : "48px")};
`;

const DataList = styled.div`
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;

  span {
    font-size: 14px;
    color: #434343;
    letter-spacing: 0.48px;
  }
  & span:nth-child(1) {
    flex-wrap: wrap;
  }
  & span:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    font-weight: 600;
    max-width: 155px;
  }
`;

const OL = styled.ol`
  li {
    padding-left: 5px;
    margin-left: 15px;
    font-size: 14px;
    &:not(:last-child) {
      margin-bottom: 24px;
    }
    > span {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 24px;
      & span:nth-child(1) {
        max-width: 205px;
      }

      b {
        font-weight: 600;
      }
    }
    &::marker {
      font-weight: 600;
    }
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
  margin: 0 0 24px 0;
  @media screen and (min-width: 768px) {
    margin: 0;
    padding: 0;
  }
`;

const DeclarationText = styled.span`
  font-weight: normal;
`;

function PersonalInfo() {
  const urlParams: URLSearchParams = Helpers.getURLSearchParams();

  const history = useHistory();
  const dispatch = useAvivaDispatch();
  const personalInfo = useAvivaSelector(
    (state) => state.shieldStarterStep3.personalInfo
  );
  const whomToBuy = useAvivaSelector(
    (state) => state.shieldStarterStep1.whomToBuy
  );
  const policyName = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const personalChildInfo = useAvivaSelector(
    (state) => state.shieldStarterStep3.personalChildInfo
  );
  const selectedChildInfo = useAvivaSelector(
    (state) => state.shieldStarterStep3.selectedChildInfo
  );
  const transactionId = useAvivaSelector(
    (state) => state.shieldStarterStep3.transactionId
  );
  const isManualData = useAvivaSelector(
    (state) => state.shieldStarterStep3.isManualMyinfoData
  );
  const selectedPolicy = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const isRentalPostalCustomer = useAvivaSelector(
    (state) => state.shieldStarterStep3.rentalPostalCustomer
  );
  const previosError = useAvivaSelector(
    (state) => state.shieldStarterStep1.apiError
  );
  const promoCode = useAvivaSelector(
    (state) => state.shieldStarterStep2.promoCode
  );
  const singpassObjectInStore = useAvivaSelector(
    (state) => state.shieldStarterStep3
  );
  const consentForMinor: consentForMinorProps = useAvivaSelector(
    (state) => state.shieldStarterStep3.consentForMinor
  );
  const campaignCode =
    useAvivaSelector((state) => state.loading?.campaignDetail?.campaignCode) ||
    null;
  const {
    base64SignatureImage: signature,
    attachmentId: signatureAttachmentId,
  } = useAvivaSelector((state) => state.shieldStarterStep3.signature);
  const agentCode =
    useAvivaSelector((state) => state.urlAnalytic.param.arc) || null;
  const dob =
    useAvivaSelector(
      (state) => state.shieldStarterStep3.personalInfo?.dateOfBirth
    ) || null;

  const [errors, setErrors] = useState<{ [key: string]: any | null }>({});
  const [apiError, setApiError] = useState("");
  const [apiErrorTitle, setApiErrorTitle] = useState("");
  const [isDragOver, setIsDragOver] = useState(false);
  const [fileUploadError, setFileUploadError] = useState("");
  const [declarationModal, setDeclarationModal] = useState("");
  const [showSignModal, setShowSignModal] = useState(false);
  const [isConsentChanged, setIsConsentChanged] = useState(false);
  const [newConsentType, setNewConsentType] = useState("");

  const isError = apiError ? true : false;

  const alertUser = (event: any) => {
    event.preventDefault();
    event.returnValue = ""; // Required for Chrome
    return ""; // Required for Firefox
  };

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);

  const updateDropoffPoint = useCallback(async () => {
    return new Promise(async (resolve, reject) => {
      const payload = {
        transactionId,
        fullName: personalInfo?.fullName,
        salutation: personalInfo?.salutation,
        mobileNumber: personalInfo?.mobileNum,
        email: personalInfo?.emailId,
        cc: campaignCode,
        dateOfBirth: dob,
        product: selectedPolicy,
        rentalPostalCustomer: isRentalPostalCustomer,
        stayInTouch: personalInfo?.stayInTouch,
        agentCode,
        dropPoint: "QNB_SLSS_SINGPASS_DROPOFF",
      };

      try {
        const response = await postContactShield(payload);
      } catch (error) {
        console.error(error);
      }
      resolve("done");
    });
  }, [transactionId, personalInfo, isRentalPostalCustomer]);

  const getErrorTitle = (errorCode: string) => {
    let message = "";
    switch (errorCode) {
      case "1004":
        message = "You already have an existing \n Shield plan with us";
        break;

      default:
        message = "";
        break;
    }
    return message;
  };

  const onNextClick = useCallback(async () => {
    if (isError) return;
    try {
      const payload = {
        transactionId: transactionId,
        customerId: personalInfo?.customerId,
        email: personalInfo?.emailId,
        firstName: personalInfo?.firstName,
        lastName: personalInfo?.lastName,
        mobileNumber: personalInfo?.mobileNum,
        customerConsent: personalInfo?.stayInTouch,
        salutation: personalInfo?.salutation,
        insuredType: whomToBuy,
        otherProposerDetail: consentForMinor.type
          ? {
              selectedProposerCategory: consentForMinor.type,
              declarationCheck: consentForMinor.consentAccepted,
              fullName: consentForMinor.fullName,
            }
          : null,
        agentCode,
      };
      const res: any = await postValidateUserDetails(payload);
      if (!res?.data?.enableConfirm) {
        history.push(`${ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR}`);
        return;
      }

      await updateDropoffPoint();
      await fetchSqsQuotation(
        whomToBuy,
        policyName,
        dispatch,
        promoCode,
        singpassObjectInStore,
        campaignCode
      );
      dispatch(updateReadyToGoNext(true));
      history.push(`${ROUTE_PATH.SHIELD_STARTER_MAILING_ADDRESS}`);
    } catch {
      history.push(`${ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR}`);
    }
  }, [transactionId, personalInfo, consentForMinor, whomToBuy, campaignCode]);

  const handleConsent = useCallback(async (transaction_id: string) => {
    const status = urlParams.get("status");
    // To check if the manual singpass form is being used to load the personal info and to stop making api calls to fetch the data.
    if (isManualData) {
      //@ts-ignore
      if (personalInfo.error) {
        //@ts-ignore
        setApiError(personalInfo.error);
      }
      return;
    }

    if (status === "consent_accepted" && transaction_id) {
      try {
        dispatch(setLoadingState(true));
        dispatch(updateTransactionId(transaction_id));
        const { data }: any = await postMyInfoRecord(
          transaction_id,
          whomToBuy,
          selectedPolicy,
          promoCode
        );
        if (data) {
          if (data?.error && data.error?.errorMessage) {
            setApiErrorTitle(getErrorTitle(data?.error?.errorCode));
            setApiError(data.error.errorMessage);
          }
          const myselfData = data.myselfData;
          personalInfo?.salutation &&
            isEmpty(myselfData?.salutation) &&
            delete myselfData.salutation;
          personalInfo?.emailId &&
            isEmpty(myselfData?.emailId) &&
            delete myselfData.emailId;
          personalInfo?.mobileNum &&
            isEmpty(myselfData?.mobileNum) &&
            delete myselfData.mobileNum;
          if (whomToBuy === "child") {
            dispatch(updatePersonalChildInfo(data));
          }
          dispatch(updateSingpassInitiated(true));
          dispatch(updatePersonalInfo(myselfData));
          dispatch(updateRentalPostalCustomer(data?.rentalPostalCustomer));
        }
        dispatch(setLoadingState(false));
      } catch (err) {
        dispatch(setLoadingState(false));
        history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
      }
      trackOnLoad("sss_myinfo_form");
    } else {
      history.replace(
        `${ROUTE_PATH.SHIELD_STARTER_SINGPASS_PERSMISSION}?transaction_id=${transaction_id}&status=${status}`
      );
    }
  }, []);

  const errorFn = (errors: any) => {
    setErrors(errors);
  };

  const updateInfoFn = (info: any) => {
    dispatch(
      updatePersonalInfo({
        ...personalInfo,
        ...info,
      })
    );
  };

  const fileProgress: any = useAvivaSelector(
    (state) => state.shieldStarterStep3.fileProgress
  );

  const uploadedFileAmount = size(fileProgress);

  useEffect(() => {
    if (uploadedFileAmount > MAX_FILE_UPLOAD_COUNT)
      setFileUploadError(
        `We could only upload maximum of ${MAX_FILE_UPLOAD_COUNT} files, delete some files and try again.`
      );
  }, [uploadedFileAmount]);

  const pendingFiles: any = useAvivaSelector((state) =>
    toArray(state.shieldStarterStep3.fileProgress).filter(
      (file: any) => file.status === uploadStatus.QUEUE
    )
  );

  const selectFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files;
    setFileUploadError("");

    if (uploadedFileAmount + size(selectedFiles) > MAX_FILE_UPLOAD_COUNT) {
      setFileUploadError(
        `We could only upload maximum of ${MAX_FILE_UPLOAD_COUNT} files, delete some files and try again.`
      );
    }

    if (uploadedFileAmount < MAX_FILE_UPLOAD_COUNT) {
      dispatch(setUploadFile(selectedFiles));
    }

    event.target.value = "";
  };

  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(false);
    setFileUploadError("");

    const droppedFiles = Array.from(event.dataTransfer.files);
    if (uploadedFileAmount < MAX_FILE_UPLOAD_COUNT) {
      dispatch(setUploadFile(droppedFiles));
    }
  };

  const isChangeAllowed = () => {
    if (!isEmpty(fileProgress) || signature) {
      setIsConsentChanged(true);
      return false;
    }
    return true;
  };

  const handleConsentTabChange = (type: string) => {
    setNewConsentType(type);
    if (!isChangeAllowed()) return;
    dispatch(
      updateConsentForMinor({
        ...consentForMinor,
        type,
        consentAccepted: 0,
        fullName: "",
      })
    );
  };

  const handleConsentChange = () => {
    // Delete Signature
    if (signatureAttachmentId) {
      deleteFile(null, signatureAttachmentId, true);
    }

    // Delete uploaded files
    const fileToDelete = toArray(fileProgress).filter(
      (file: FileProgress) => file.status === uploadStatus.SUCCESS
    );

    fileToDelete.forEach(async (file: any) => {
      deleteFile(file.id, file.attachmentId);
    });

    dispatch(
      updateConsentForMinor({
        ...consentForMinor,
        type: newConsentType,
        consentAccepted: 0,
        fullName: "",
      })
    );
    dispatch(clearUploadedFiles());
    setIsConsentChanged(false);
  };

  const handleConsentChangeCancel = () => {
    setIsConsentChanged(false);
  };

  useEffect(() => {
    if (pendingFiles) uploadFile(pendingFiles);
  }, [pendingFiles]);

  const uploadFile = async (files: any) => {
    if (files.length) {
      files.forEach(async (file: any) => {
        try {
          if (!transactionId)
            throw new Error("Upload failed. Reload or attach file again.");

          if (!isFileSizeAllowed(file.file))
            throw new Error(
              `File exceeds ${MAX_FILE_SIZE_MB} limit. Attach smaller file.`
            );

          if (!isFileTypeAllowed(file))
            throw new Error(
              `File not supported. Attach in ${ACCEPTED_FILE_TYPES}`
            );

          if (isFileDuplicated(fileProgress, file))
            throw new Error(
              "Upload failed. You already have a file with the same name and file format."
            );

          dispatch(
            setUploadProgress({
              id: file.id,
              progress: 0,
            })
          );

          const formPayload = new FormData();
          formPayload.append("transactionId", transactionId);
          formPayload.append("documentType", "profile");
          formPayload.append("fileType", file.file.type);
          formPayload.append("attachment", file.file);

          const { data }: any = await uploadDocuments(formPayload, {
            cancelToken: file.cancelSource.token,
            onUploadProgress: (progress: any) => {
              const { loaded, total } = progress;

              const percentageProgress = Math.floor((loaded / total) * 100);
              // TODO : add debouncing
              dispatch(
                setUploadProgress({
                  id: file.id,
                  progress: percentageProgress,
                })
              );
            },
          });
          dispatch(
            successUploadFile({ id: file.id, attachmentId: data.attachmentId })
          );
        } catch (e) {
          let error = "";
          //@ts-ignore
          if (!e?.response?.status) error = (e as Error)?.message;
          //@ts-ignore
          if (e?.response?.data?.message) error = e?.response?.data?.message;

          dispatch(
            failureUploadFiles({
              id: file.id,
              error: error || "Upload failed. Reload or attach file again.",
            })
          );
        }
      });
    }
  };

  const retryFile = (file: any) => {
    uploadFile([file]);
  };

  const deleteFile = async (
    fileId: number | null,
    attachmentId: string,
    isSignatureDelete = false
  ) => {
    try {
      setFileUploadError("");
      dispatch(setLoadingState(true));
      if (attachmentId) await deleteDocuments(attachmentId);
      if (fileId) dispatch(deleteUploadedFile(fileId));
      if (isSignatureDelete) dispatch(deleteSignature());
      dispatch(setLoadingState(false));
    } catch (e) {
      dispatch(setLoadingState(false));
      if (fileId) {
        dispatch(
          failureUploadFiles({
            id: fileId,
            error: "Failed to delete file. Try again.",
          })
        );
      }
      if (isSignatureDelete) dispatch(deleteSignature());
    }
  };

  useEffect(() => {
    const transaction_id: string = urlParams.get("transaction_id") || "";
    const isManualDataParam: string = urlParams.get("manual_data") || "";
    if (isManualDataParam === "available") {
      dispatch(updateSingpassInitiated(true))
      trackOnLoad("sss_myinfo_from_manual_form");
      //@ts-ignore
      if (personalInfo?.errorMessage) {
        //@ts-ignore
        setApiError(personalInfo?.errorMessage);
        //@ts-ignore
        setApiErrorTitle(getErrorTitle(personalInfo?.errorCode));
      }
      return;
    }
    if (transactionId === transaction_id) {
      return;
    }
    if (personalInfo) {
      dispatch(updatePersonalInfo({}));
    }
    handleConsent(transaction_id);
  }, []);

  useEffect(() => {
    if (apiError) dispatch(updateApiError(apiError));
  }, [apiError]);

  useEffect(() => {
    if (previosError) setApiError(previosError);
  }, []);

  const getColor = (type: string, color: string) => {
    let defaultColor = null;
    let activeColor = null;

    switch (color) {
      case "bgColor":
        defaultColor = themeDefault.colors.grey[1300];
        activeColor = themeDefault.colors.primary;
        break;
      case "textColor":
        defaultColor = themeDefault.colors.grey[1200];
        activeColor = themeDefault.colors.white;
        break;
      case "hoverBgColor":
        defaultColor = themeDefault.colors.white;
        activeColor = themeDefault.colors.primary;
        break;
      case "hoverTextColor":
        defaultColor = themeDefault.colors.primary;
        activeColor = themeDefault.colors.white;
        break;
      default:
        break;
    }

    return type === consentForMinor?.type ? activeColor : defaultColor;
  };

  const isConsentAccepted = useCallback(() => {
    if (
      whomToBuy === "child" ||
      !personalInfo?.age ||
      personalInfo?.age < 17 ||
      personalInfo?.age > 21
    )
      return false;

    if (
      consentForMinor?.type === ConsentTypes.NEITHER &&
      consentForMinor?.consentAccepted === 1
    )
      return false;

    if (
      consentForMinor?.type === ConsentTypes.PARENT &&
      signature !== "" &&
      consentForMinor?.consentAccepted === 1 &&
      consentForMinor?.fullName !== ""
    )
      return false;

    const inprogressFiles = toArray(fileProgress).filter((file: FileProgress) =>
      [
        uploadStatus.QUEUE,
        uploadStatus.UPLOADING,
        uploadStatus.INACTIVE,
      ].includes(file.status)
    );

    if (
      consentForMinor?.type === ConsentTypes.GUARDIAN &&
      signature !== "" &&
      consentForMinor?.consentAccepted === 1 &&
      consentForMinor?.fullName !== "" &&
      size(fileProgress) > 0 &&
      inprogressFiles?.length === 0
    )
      return false;

    return true;
  }, [signature, consentForMinor, whomToBuy, personalInfo, fileProgress]);

  return (
    <MainContainer
      step={3}
      backButtonPath={ROUTE_PATH.SHIELD_STARTER_START_APPLICATION}
    >
      {/* <TitleAndDescription
        title="Check your details"
        description="Your details were filled automatically from Myinfo."
      /> */}
      <ContentContainer>
        <Typography variant="title" align="center">
          Check your details
        </Typography>
        <Typography
          variant="description"
          align="center"
          color={themeDefault.colors.grey[1200]}
        >
          Your details were filled automatically from Myinfo.
        </Typography>
      </ContentContainer>
      {personalChildInfo && whomToBuy === "child" && (
        <ChildInfo items={personalChildInfo} />
      )}
      <SectionContainer>
        <Text
          fSize="18px"
          mg="0 0 24px 0"
          style={{
            borderBottom: `1px solid ${themeDefault.colors.grey[700]}`,
            paddingBottom: "24px",
            width: "100%",
          }}
        >
          {whomToBuy === "child"
            ? "Applicant - Personal Information"
            : "Personal Information"}
        </Text>
        {personalInfo?.fullName && (
          <MyInfoForm
            personalInfo={personalInfo}
            updateInfoFn={updateInfoFn}
            errorFn={errorFn}
          />
        )}
      </SectionContainer>
      {whomToBuy === "myself" &&
        personalInfo?.age >= 17 &&
        personalInfo?.age <= 21 && (
          <SectionContainer>
            <Text fSize="18px" mg="0 0 8px 0">
              Consent for Minor
            </Text>
            <Text
              fSize="14px"
              mg="0 0 24px 0"
              color={themeDefault.colors.grey[1200]}
              weight={400}
            >
              If you are aged <b>17 to 21</b> years old (age next birthday),
              consent is required from your parent/legal guardian for your
              application's MediSave deduction.Select "Neither" if this is not
              applicable.
            </Text>
            <Center style={{ marginTop: "24px" }}>
              <Button
                label="Parent"
                bgColor={getColor(ConsentTypes.PARENT, "bgColor")}
                textColor={getColor(ConsentTypes.PARENT, "textColor")}
                hoverBgColor={getColor(ConsentTypes.PARENT, "hoverBgColor")}
                hoverTextColor={getColor(ConsentTypes.PARENT, "hoverTextColor")}
                borderColor="rgba(111,111,111,0.2) transparent transparent"
                variant="default"
                margin={"0 8px 0 0"}
                width="216px"
                onClick={() => {
                  handleConsentTabChange(ConsentTypes.PARENT);
                }}
                className={ConsentButtonCss}
              />
              <Button
                label="Legal Guardian"
                bgColor={getColor(ConsentTypes.GUARDIAN, "bgColor")}
                textColor={getColor(ConsentTypes.GUARDIAN, "textColor")}
                hoverBgColor={getColor(ConsentTypes.GUARDIAN, "hoverBgColor")}
                hoverTextColor={getColor(
                  ConsentTypes.GUARDIAN,
                  "hoverTextColor"
                )}
                borderColor="rgba(111,111,111,0.2) transparent transparent"
                variant="default"
                margin={"0 8px 0 0"}
                width="216px"
                onClick={() => {
                  handleConsentTabChange(ConsentTypes.GUARDIAN);
                }}
                className={ConsentButtonCss}
              />
              <Button
                label="Neither"
                bgColor={getColor(ConsentTypes.NEITHER, "bgColor")}
                textColor={getColor(ConsentTypes.NEITHER, "textColor")}
                hoverBgColor={getColor(ConsentTypes.NEITHER, "hoverBgColor")}
                hoverTextColor={getColor(
                  ConsentTypes.NEITHER,
                  "hoverTextColor"
                )}
                borderColor="rgba(111,111,111,0.2) transparent transparent"
                variant="default"
                margin={"0"}
                width="216px"
                onClick={() => {
                  handleConsentTabChange(ConsentTypes.NEITHER);
                }}
                className={ConsentButtonCss}
              />
            </Center>
            {consentForMinor?.type && (
              <SelectedParent style={{ marginTop: "48px" }}>
                {consentForMinor?.type !== ConsentTypes.NEITHER && (
                  <>
                    <InputGroup
                      labelColor={themeDefault.colors.grey[500]}
                      id="fullName"
                      name="fullName"
                      label={`Full Name of ${
                        CONSENT_LABEL[consentForMinor?.type]
                      }`}
                      placeholder=""
                      invalid={!isEmpty(errors?.fullname?.message)}
                      errorMessage={errors?.fullname?.message}
                      inputProps={{
                        textAlign: "left",
                        value: consentForMinor?.fullName,
                      }}
                      inputType={"input"}
                      onChange={(e: any) => {
                        const regex = /^\s*.{0,50}\s*$/;
                        const value = e.target.value;
                        if (regex.test(value))
                          dispatch(
                            updateConsentForMinor({
                              ...consentForMinor,
                              fullName: value,
                            })
                          );
                      }}
                    />
                    <SignArea>
                      <Label>
                        Signature of {CONSENT_LABEL[consentForMinor?.type]}
                      </Label>
                      <SignBox onClick={() => setShowSignModal(true)}>
                        {signature ? (
                          <SignImage
                            src={`data:image/png;base64,${signature}`}
                            alt="signature"
                          />
                        ) : (
                          "Click to sign"
                        )}
                      </SignBox>
                    </SignArea>
                  </>
                )}
                {consentForMinor?.type === ConsentTypes.GUARDIAN && (
                  <>
                    <AttachFileDiv
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      isDragOver={isDragOver}
                      isDisabled={uploadedFileAmount >= MAX_FILE_UPLOAD_COUNT}
                    >
                      <Label>Proof of Legal Guardian</Label>
                      <SignContainer
                        isDisabled={uploadedFileAmount >= MAX_FILE_UPLOAD_COUNT}
                      >
                        <input
                          type="file"
                          id="upload-btn"
                          hidden
                          accept=".pdf,.jpg,.jpeg,.png" // temporary removed doc and ppt formats
                          // accept=".pdf,.doc,.docx,.ppt,.pptx,.jpg,.jpeg,.png"
                          multiple
                          onChange={selectFiles}
                        />
                        <label htmlFor="upload-btn" className={AttachFileCss}>
                          <img
                            width="18px"
                            height="18px"
                            src={AttachFileIcon}
                            alt={"info-icon"}
                            style={{ marginRight: "8px" }}
                          />
                          {`Attach file (up to ${MAX_FILE_UPLOAD_COUNT} files)`}
                        </label>
                      </SignContainer>
                      <span>
                        {size(fileProgress)
                          ? toArray(fileProgress).map((file) => (
                              <FileUploadCard
                                key={file.id}
                                file={file}
                                deleteFile={deleteFile}
                                retryFile={retryFile}
                              />
                            ))
                          : null}
                      </span>
                    </AttachFileDiv>
                    {fileUploadError && (
                      <Text
                        fSize="12px"
                        color="#C50000"
                        style={{ padding: "8px" }}
                      >
                        {fileUploadError}
                      </Text>
                    )}
                    <Info>
                      <img
                        width="18px"
                        height="18px"
                        src={infoIconBlack}
                        alt={"info-icon"}
                      />
                      <span>
                        Follow these
                        <Link
                          color={themeDefault.colors.primary}
                          underline={false}
                          fontSize={14}
                          text=" file"
                          variant="button"
                          fontWeight="600"
                          onClick={() => setDeclarationModal("file")}
                        />{" "}
                        and
                        <Link
                          color={themeDefault.colors.primary}
                          underline={false}
                          fontSize={14}
                          text=" photo"
                          variant="button"
                          fontWeight="600"
                          onClick={() => setDeclarationModal("photo")}
                        />{" "}
                        guidelines when uploading.
                      </span>
                    </Info>
                  </>
                )}
                <AcceptConsent
                  noMargin={consentForMinor?.type === ConsentTypes.NEITHER}
                >
                  <Checkbox
                    checked={consentForMinor?.consentAccepted === 1}
                    onChange={(e: any) =>
                      dispatch(
                        updateConsentForMinor({
                          ...consentForMinor,
                          consentAccepted: e.target.value ? 1 : 0,
                        })
                      )
                    }
                  >
                    <DeclarationText>
                      {CONSENT_ACCEPT_DECLARATION[consentForMinor?.type]}
                    </DeclarationText>
                  </Checkbox>
                </AcceptConsent>
              </SelectedParent>
            )}
          </SectionContainer>
        )}
      <SectionContainer>
        <Text fSize="16px">Let’s stay in touch – on your terms</Text>
        <Text
          mbFsize="14px"
          color={themeDefault.colors.grey[1200]}
          weight={400}
          mg={"8px 0 24px 0"}
        >
          Experience better ways to financial freedom with our exclusive offers
          and news via email, mail, calls and messaging platforms. Simply tell
          us if you’re interested and update your preference anytime!
        </Text>
        <Checkbox
          type="radio"
          checked={
            personalInfo["stayInTouch"] === "SMS,Y|Phone,Y|Mail,Y|EMail,Y"
          }
          name="stayInTouch"
          newRedio={true}
          margin="0 0 24px 0"
          onChange={() => {
            let target = {
              target: {
                name: "stayInTouch",
                value: "yes",
              },
            };
            dispatch(
              updatePersonalInfo({
                ...personalInfo,
                stayInTouch: "SMS,Y|Phone,Y|Mail,Y|EMail,Y",
              })
            );
          }}
        >
          <TextNormal>
            Yes please, I want to hear about offers and news just for me
          </TextNormal>
        </Checkbox>
        <Checkbox
          type="radio"
          checked={
            personalInfo["stayInTouch"] === "SMS,N|Phone,N|Mail,N|EMail,N"
          }
          name="stayInTouch"
          newRedio={true}
          onChange={() => {
            dispatch(
              updatePersonalInfo({
                ...personalInfo,
                stayInTouch: "SMS,N|Phone,N|Mail,N|EMail,N",
              })
            );
          }}
        >
          <TextNormal>
            No thanks, I don’t want to hear about offers and news just for me
          </TextNormal>
        </Checkbox>
        <Text
          mbFsize="12px"
          weight={500}
          color={themeDefault.colors.grey[1200]}
          mg="24px 0 0"
        >
          Update your preference anytime, anywhere at MySinglife {" ("}
          <Link
            text=" www.singlife.com/mysinglife "
            variant="link"
            target="_blank"
            rel="noopener noreferrer"
            url="https://www.singlife.com/mysinglife"
            color={themeDefault.colors.primary}
            fontSize={12}
            fontSizeTablet={12}
            underline
          />
          {") "}
          or contact Singlife at{" "}
          <Link
            text=" +65 6827 9933. "
            variant="link"
            url="tel:+6568279933"
            color={themeDefault.colors.primary}
            fontSize={12}
            fontSizeTablet={12}
            underline
            className={LinkCss}
          />
        </Text>
      </SectionContainer>
      <Wrap>
        <Text mbFsize="14px" fSize="12px" mg="64px 0" weight={400}>
          The details you provided for mobile number and email address will be
          updated in MySinglife records for all your general insurance, life and
          health policies except for MINDEF/MHA/POGIS after successful
          application.
        </Text>
        <Center>
          <Button
            label="Confirm"
            variant="default"
            width="180px"
            height="52px"
            padding="15px 0"
            margin="0 0 24px"
            disabled={
              !personalInfo["stayInTouch"] ||
              !personalInfo["salutation"] ||
              !personalInfo["emailId"] ||
              !personalInfo["mobileNum"] ||
              (whomToBuy === "child" && isEmpty(selectedChildInfo)) ||
              !errors?.emailId?.isValid ||
              !errors?.mobileNum?.isValid ||
              isError ||
              isConsentAccepted()
            }
            onClick={onNextClick}
          />
        </Center>
      </Wrap>

      {apiError && <ErrorModal error={apiError} title={apiErrorTitle} />}

      <Modal
        onClose={() => setDeclarationModal("")}
        show={declarationModal === "file"}
      >
        <Text fSize="18px" mg="0 0 16px 0">
          File requirements
        </Text>
        {FILE_INSTRUCTIONS?.map((entries: any) => {
          return (
            <DataList>
              <span>{entries.label}</span>
              <span>{entries.value}</span>
            </DataList>
          );
        })}
      </Modal>
      <Modal
        onClose={() => setDeclarationModal("")}
        show={declarationModal === "photo"}
      >
        <Text fSize="18px" mg="0 0 16px 0">
          Photo guidelines
        </Text>
        {
          <OL>
            <li>
              <span>
                <span>
                  Leave a <b>minimum of 2cm spacing</b> around the edges
                  (slightly longer than your thumb width).
                </span>
                <img
                  width="60px"
                  height="60px"
                  src={photoGuidIcon1}
                  alt={"info-icon"}
                />
              </span>
            </li>
            <li>
              <span>
                <span>
                  Place document <b>against dark background</b>.
                </span>
                <img
                  width="60px"
                  height="60px"
                  src={photoGuidIcon2}
                  alt={"info-icon"}
                />
              </span>
            </li>
            <li>
              <span>
                <span>
                  Ensure <b>sufficient lighting</b> for easy reading and
                  clarity.
                </span>
                <img
                  width="60px"
                  height="60px"
                  src={photoGuidIcon3}
                  alt={"info-icon"}
                />
              </span>
            </li>
            <li>
              <span>
                <span>
                  Take <b>individual</b> photo for <b>each document</b>.
                </span>
                <img
                  width="60px"
                  height="60px"
                  src={photoGuidIcon4}
                  alt={"info-icon"}
                />
              </span>
            </li>
          </OL>
        }
      </Modal>

      {showSignModal && (
        <Modal onClose={() => setShowSignModal(false)} show={showSignModal}>
          <SingnatureCanvas
            showSignModal={setShowSignModal}
            consentType={consentForMinor.type}
          />
        </Modal>
      )}
      <Modal show={isConsentChanged} onClose={handleConsentChangeCancel}>
        <ConsentChangeModal
          onYesClick={handleConsentChange}
          onNoClick={handleConsentChangeCancel}
        />
      </Modal>
    </MainContainer>
  );
}
export default PersonalInfo;
